export const INIT_CART_INFO = 'INIT_CART_INFO'
export const TOGGLE_MODEL = 'TOGGLE_MODEL'
export const SELECT_GOODS = 'SELECT_GOODS'
export const SELECT_GROUP = 'SELECT_GROUP'
export const SELECT_ALL = 'SELECT_ALL'
export const UPDATE_CART_GOODS_BY_ID = 'UPDATE_CART_GOODS_BY_ID'
export const DELETE_CART_GOODS_BY_IDS = 'DELETE_CART_GOODS_BY_IDS'
export const CLEAR_CART = 'CLEAR_CART'



// WEBPACK FOOTER //
// ./src/logic/cart/mutation-types.js